import { ISearchSuggestionProps } from '@1js/search-types';
import { IO365ShellShim } from '@suiteux/suiteux-shell';
import React from 'react';
import { ClassNames } from '../../shared/icon-font/icon-font-classes.utility';
import { IconFontType } from '../../shared/icon-font/icon-font-type.enum';
import { SearchInstrumentationService, SearchResultElementId, SearchResultType } from '../search-instrumentation.service';
import { SearchSuggestionButtonComponent } from './search-suggestion-components/search-suggestion-button.component';

interface HelpProps extends ISearchSuggestionProps {
    readonly isDarkMode: boolean;
    readonly isPwa: boolean;
    readonly searchInstrumentationService: SearchInstrumentationService;
    readonly title?: string;
    readonly articleId?: string;
    readonly shellShim?: IO365ShellShim;
}

export class HelpSearchSuggestionComponent extends React.Component<HelpProps> {

    public readonly handleClick = () => () => {

        this.props.shellShim.NFD.OpenHelp(this.props.articleId);

        this.props.searchInstrumentationService.logSearchClickEvent(
                                                    SearchResultType.Help,
                                                    SearchResultElementId.Help,
                                                    false,
                                                    SearchResultType.Help,
                                                    this.props.articleId,
                                                    undefined,
                                                    undefined,
                                                    this.props.id
                                                );
    }

    public render() {
        const iconClass = ClassNames.FluentIconCssClass;
        const iconSVGClass = ClassNames.SvgIconCssClass;
        return (
            <SearchSuggestionButtonComponent
                title={this.props.title}
                icon={iconSVGClass + ' ' +
                      iconClass + ' ' +
                      ClassNames.getCssClass(IconFontType.Question) +
                      (this.props.isDarkMode && this.props.isPwa ? ' search-Icon--darkMode' : '')}
                isDarkMode={this.props.isDarkMode}
                isPwa={this.props.isPwa}
                handleClick={this.handleClick()}
                target='_self'
                />
        );
    }
}
